export const RegisterSmsModel = function () {
    this.citizenid = ""
    this.otp = ""
    this.refcode = ""
}

export const RegisterOtpModel = function () {
    this.citizenid = ""
    this.lineid = ""
    this.localeId = 1054

}
export const RegisterSmsCheckContactNumberModel = function () {
    this.citizenid = ""
    this.is_accepted = false
}

RegisterSmsCheckContactNumberModel.prototype.getParams = function () {
    let json = {
        citizenid: this.citizenid,
        is_accepted: this.is_accepted
    }

    return json
}